import { useEffect, useState } from "react";
import { pendingCount, QUEUE_EVENT } from "../lib/offlineQueue";

export function useConnection() {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const [pending, setPending] = useState(pendingCount());

  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    const onQueue = (e) => setPending(e?.detail?.count ?? pendingCount());
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    window.addEventListener(QUEUE_EVENT, onQueue);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
      window.removeEventListener(QUEUE_EVENT, onQueue);
    };
  }, []);

  return { online, pending };
}
